// NekedSzedtem Landing Page - Mock Data
// PLACEHOLDERS - Könnyen cserélhető adatok

export const contactInfo = {
  phone: "+36 70 289 2387",
  email: "csaknekedszedtem@gmail.com",
  formspreeEndpoint: "https://formspree.io/f/xvzgwrzg"
};

export const heroContent = {
  title: "Esküvői & Rendezvény Dekoráció",
  brandName: "NekedSzedtem",
  description: "Egyedi, személyre szabott dekorációk, amelyek tökéletesen illeszkednek álmaid napjához. Harmonikus színvilág, precíz kivitelezés, felejthetetlen pillanatok.",
  primaryCta: "Ajánlatkérés",
  secondaryCta: "Galéria megtekintése",
  backgroundImage: "/images/gallery/hero.jpg",

};

export const uspItems = [
  {
    id: 1,
    icon: "Palette",
    title: "Egyedi Koncepció & Stílus",
    description: "Minden dekoráció személyre szabott – a te ízlésed, a te történeted."
  },
  {
    id: 2,
    icon: "Heart",
    title: "Esküvő- & Rendezvényfókusz",
    description: "Kizárólag rendezvényekre specializálódtunk, így a maximumot kapod."
  },
  {
    id: 3,
    icon: "CheckCircle",
    title: "Precíz Szervezés",
    description: "Megbízható kivitelezés, időben, pontosan – hogy neked ne kelljen aggódnod."
  },
  {
    id: 4,
    icon: "Leaf",
    title: "Természetközeli Szemlélet",
    description: "Fenntartható anyagok, természetes szépség, tudatos választások."
  }
];

export const services = [
  {
    id: 1,
    title: "Esküvői Dekoráció",
    description: "Teljes körű esküvői dekoráció: szertartáshelyszín, vacsoraasztalok, fotósarok és minden apró részlet, ami tökéletessé teszi a nagy napot.",
    features: ["Szertartás dekoráció", "Asztaldíszek", "Fotósarok kialakítás", "Helyszín styling"]
  },
  {
    id: 2,
    title: "Rendezvénydekoráció",
    description: "Céges események, privát ünnepségek, gálák – professzionális dekoráció minden alkalomra, a koncepcióalkotástól a kivitelezésig.",
    features: ["Céges rendezvények", "Privát ünnepségek", "Tematikus események", "Gálák & fogadások"]
  },
  {
    id: 3,
    title: "Konzultáció & Látványterv",
    description: "Személyes egyeztetés, ahol megismerjük elképzeléseidet, és részletes látványtervet készítünk a tökéletes végeredményért.",
    features: ["Személyes konzultáció", "Részletes látványterv", "Anyag- & színminta", "Költségvetés tervezés"]
  }
];

export const galleryImages = [
  { id: 1,  src: "/images/gallery/g01.jpg", alt: "Hosszú kültéri esküvői asztal fehér terítéssel és ültetéssel", category: "Esküvő" },
  { id: 2,  src: "/images/gallery/g02.jpg", alt: "Hangulatos vacsoraasztal gyertyafénnyel és virágokkal", category: "Dekoráció" },
  { id: 3,  src: "/images/gallery/g03.jpg", alt: "Falatozók és apró részletek – tálalás dekorációval", category: "Részletek" },
  { id: 4,  src: "/images/gallery/g04.jpg", alt: "Fehér asztali dekoráció kék poharakkal és textíliákkal", category: "Dekoráció" },
  { id: 5,  src: "/images/gallery/g05.jpg", alt: "Menyasszonyi csokor karakteres színekkel – rózsaszín és bordó tónusok", category: "Csokor" },

  { id: 6,  src: "/images/gallery/g06.jpg", alt: "Menyasszonyi styling – letisztult enteriőrben", category: "Styling" },
  { id: 7,  src: "/images/gallery/g07.jpg", alt: "Torta- és desszertasztal virágos kiegészítőkkel", category: "Dekoráció" },
  { id: 8,  src: "/images/gallery/g08.jpg", alt: "Asztali díszítés részlet – tányérok, textil, gyümölcsök", category: "Részletek" },
  { id: 9,  src: "/images/gallery/g09.jpg", alt: "Kék textil és desszert kompozíció – hangulatkép", category: "Részletek" },

  { id: 10, src: "/images/gallery/g10.jpg", alt: "Piknik stílusú dekoráció panorámás helyszínen – virágokkal és falatokkal", category: "Esküvő" },
  { id: 11, src: "/images/gallery/g11.jpg", alt: "Medence melletti esküvői asztal – kék-fehér dekorációval", category: "Esküvő" },
  { id: 12, src: "/images/gallery/g12.jpg", alt: "Medence melletti teríték és dekoráció – részletfotó", category: "Dekoráció" },

  { id: 13, src: "/images/gallery/g13.jpg", alt: "Szertartás pillanat – természetes, vidám hangulat", category: "Szertartás" },
  { id: 14, src: "/images/gallery/g14.jpg", alt: "Menyasszony csokorral – romantikus portré", category: "Csokor" },
  { id: 15, src: "/images/gallery/g15.jpg", alt: "Esküvői pillanat vendégekkel – mosoly és felszabadultság", category: "Szertartás" },
];




export const aboutContent = {
  title: "Rólunk",
  paragraphs: [
    "A NekedSzedtem csapata több éves tapasztalattal rendelkezik az esküvői és rendezvény dekoráció területén. Számunkra minden projekt egyedi alkotás – nem gyártunk sablonokat, hanem a te személyiségedet, stílusodat és álmaidat formáljuk valósággá.",
    "Hiszünk abban, hogy a részletek teszik tökéletessé az egészet. Ezért minden virágszálat, minden textúrát és színt gondosan válogatunk össze, hogy harmonikus, lélegzetelállító végeredményt kapj.",
    "Együttműködésünk az első konzultációtól a nagy napig tart – végigkísérünk az úton, és gondoskodunk róla, hogy minden a helyén legyen."
  ]
};

export const pressItem = {
  title: "Forbes megjelenés",
  linkText: "Fenntartható virágművészet: Neked Szedtem",
  linkUrl: "https://www.forbes.hu/tamogatoi-tartalom/fenntarthato-viragmuveszet-neked-szedtem/",
  description: "Büszkék vagyunk, hogy a Forbes is felfigyelt fenntartható szemléletünkre és egyedi megközelítésünkre."
};

export const socialLinks = {
  instagram: "https://www.instagram.com/neked_szedtem/?hl=en",
  facebook: "https://www.facebook.com/profile.php?id=100086545705983"
};

export const navItems = [
  { label: "Miért mi?", href: "#miert-mi" },
  { label: "Szolgáltatások", href: "#szolgaltatasok" },
  { label: "Galéria", href: "#galeria" },
  { label: "Rólunk", href: "#rolunk" },
  { label: "Kapcsolat", href: "#kapcsolat" }
];
